import { useObservabilityConfig, useProject } from "@sail/observability";
import { useMemo } from "react";
import mergeExpectedErrors from "./mergeExpectedErrors";
import useDataConfig from "../config/useDataConfig";
import useObservabilityFns from "../../shared/observability/useObservabilityFns";
export function useDataContext() {
    var _useObservabilityConfig;
    const observabilityFns = useObservabilityFns();
    const queryProject = useProject();
    const service = (_useObservabilityConfig = useObservabilityConfig()) === null || _useObservabilityConfig === void 0 ? void 0 : _useObservabilityConfig.service;
    const dataConfig = useDataConfig();
    const expectedErrorsFromDataConfig = dataConfig.observability.expectedErrors;
    var // @ts-expect-error - property purposefully not typed to leave it "secret"
    _dataConfig_do_not_use_private_suspenseEnabled;
    const shouldUseSuspense = (_dataConfig_do_not_use_private_suspenseEnabled = dataConfig.do_not_use_private_suspenseEnabled) !== null && _dataConfig_do_not_use_private_suspenseEnabled !== void 0 ? _dataConfig_do_not_use_private_suspenseEnabled : false;
    return useMemo(()=>{
        return {
            expectedErrorsFromDataConfig,
            headers: {},
            observabilityFns,
            queryProject,
            service,
            shouldUseSuspense
        };
    }, [
        expectedErrorsFromDataConfig,
        observabilityFns,
        queryProject,
        service,
        shouldUseSuspense
    ]);
}
export function getApolloContext(dataContext, graphQlOperation, component) {
    const graphQlOperationWithAllExpectedErrors = mergeExpectedErrors(dataContext.expectedErrorsFromDataConfig, graphQlOperation);
    return {
        observabilityFns: dataContext.observabilityFns,
        queryProject: dataContext.queryProject,
        service: dataContext.service,
        headers: {},
        graphQlOperation: graphQlOperationWithAllExpectedErrors,
        component
    };
}

//# sourceMappingURL=operationContext.js.map